import { useEffect } from 'react'

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export const SEO_DEFAULTS = {
  title: 'VCARS | Usados seleccionados, 0KM, financiación y permutas',
  description:
    'En VCARS encontrá autos usados seleccionados, vehículos 0KM, financiación, toma de permutas y gestión profesional para vender tu auto.',
  keywords:
    'autos usados, autos 0km, venta de autos, comprar auto, vender mi auto, financiación autos, permutas, usados seleccionados, VCARS',
}

export function useSeo(title?: string, description?: string) {
  useEffect(() => {
    document.title = title ?? SEO_DEFAULTS.title
    const desc = description ?? SEO_DEFAULTS.description
    setMeta('name', 'description', desc)
    setMeta('name', 'keywords', SEO_DEFAULTS.keywords)
    setMeta('property', 'og:title', title ?? SEO_DEFAULTS.title)
    setMeta('property', 'og:description', desc)
    setMeta('property', 'og:type', 'website')
  }, [title, description])
}
